import { enquiryStore } from "../enquiry/enquiry-data";
import { dataListStore } from "../state/CommonState";
import { SHIPMENT_SCOPE } from "../util/constants";
import Utils from "../util/Utils";





export const filtersGenerationRules = [
    {
        label:"Nomination Rates",
        isAccordionView:true,
        includeFilter:()=>{
            const {shipmentType,shipmentScope,enqRoute:{origin}} = enquiryStore.current
            
            if(shipmentType==="LCL" && (shipmentScope === SHIPMENT_SCOPE.p2p || shipmentScope === SHIPMENT_SCOPE.d2p) && origin.toLowerCase().includes("india")){
                return true
            }
            return false;
        },
        generateOptions : (records)=>{
            let options = [{title:"Nomination Rates",isChecked:false,records:[]}];
            records.forEach((record)=>{
                if(record.sources && (record.sources['oceanfreight_fairterms'] || record.sources['lclsailingschedulemaster'] || record.sources['export_oceanfreight_fairterms'] )){
                   options[0].records.push(record.uid);
                }
            })
            return options;
        }
    },
    {
        label:"Direct Routes",
        isAccordionView:true,
        toggleResults:true,
        includeFilter:()=>{
            const {shipmentType} = enquiryStore.current
            
            if(shipmentType?.toUpperCase()==="LCL"){
                return true
            }
            return false;
        },
        generateOptions : (records)=>{
            let options = [{title:"Direct Routes",isChecked:false,records:[]}];
            records.forEach((record)=>{
                if(record.rep === ""){
                   options[0].records.push(record.uid);
                }
            })
            return options;
        }
    },
    {
        label:"Transhipment",
        includeFilter:()=>{
           const {shipmentType} = enquiryStore.current;
           if(shipmentType.toLowerCase().includes("lcl") || shipmentType.toLowerCase().includes("fcl")) return true;
           return false;
        },
        generateOptions : (records)=>{
           let options = [];
           records?.forEach((record)=>{
               if(record.dummyContract.schedules?.length>0 && record.dummyContract.schedules[0].ts1?.length>0){
                let value = record.dummyContract.schedules[0].ts1
                let curRecord = {...record}
                if(value){
                    let option = options.find(({title})=>title===value)
                    if(!option){
                        options.push({title:value,isChecked:false,records:[curRecord.uid]})
                    }else{
                        option.records.push(curRecord.uid)
                    }
                }
               }
           })
           return options;
        }
    },
    {
        label : ({shipmentType="FCL"}) => shipmentType.split(" ")[0].toLowerCase() === "fcl" ? "Carrier" : "Airline",
        includeFilter : ()=>{ 
            const shipmentType = enquiryStore.current.shipmentType
            return shipmentType?.toLowerCase()!=="lcl"
        },
        generateOptions:(records)=>{
           
            let options = [];
            let keysThatHaveValues = ["scac","airline"];
            records?.forEach((record)=>{
                let value = Utils.findAndReturnFirstValueMatches(record,keysThatHaveValues);
                let curRecord = {...record}
                if(value){
                    let option = options.find(({title})=>title===value)
                    let carrierName = undefined
                     console.log(" the fcl carriers ",dataListStore["FCLCarrierList"])
                     let fclCarrierList = dataListStore["FCLCarrierList"];
                    if(fclCarrierList?.length>0) {
                       carrierName = fclCarrierList.find((list)=>list["SCAC code"] === value);
                    }
                    if(!option){
                        options.push({title:value,optionLabel:"fcl" === "fcl" ? carrierName ? carrierName["Carrier Name"]: value : undefined,isChecked:false,records:[curRecord.uid]})
                    }else{
                        option.records.push(curRecord.uid)
                    }
                }
            })
            return options;
        },
    },
    {
        label: "Price Type",
        includeFilter : ()=>{
            const shipmentType = enquiryStore.current.shipmentType;
            if(shipmentType?.toLowerCase().includes("fcl")){
               return true
            }
            return false
        },
        generateOptions:(records)=>{
            let options = [{title:"Spot",isChecked:false,records:[]},{title:"Regular",isChecked:false,records:[]}];
            records.forEach((record)=>{
                if((record.set>=6 && record.set<7) || ((record.set>=5 && record.set<6) && (record.scac?.toUpperCase()==="HPLU" || record.scac?.toUpperCase()==="MSCU") ) ){
                    options[0].records.push(record.uid)
                }else{
                    options[1].records.push(record.uid)
                }
            })
            return options;
        }
    },
    {
        label : "POR Available",
        includeFilter : ()=>{
           const {shipmentType,shipmentScope} = enquiryStore.current
           if((shipmentType.toLowerCase().includes("lcl") || shipmentType.toLowerCase().includes("fcl")) && (shipmentScope===SHIPMENT_SCOPE.d2d || shipmentScope===SHIPMENT_SCOPE.d2p) ){
            return true
           }
           return false;
        },
        generateOptions:(records)=>{
            let options = [];
            let keysThatHaveValues = "por";
            records?.forEach((record)=>{
            //    if(record[keysThatHaveValues]!==record["pol"]){
                let value = Utils.isValidValue(record[keysThatHaveValues]);
                if(value){
                    value = Utils.getPortLocation(value);
                    let option = options.find(({title})=>title===value)
                    let curRecord = {...record}
                    if(!option){
                        options.push({title:value,isChecked:false,records:[curRecord.uid]})
                    }else{
                        option.records.push(curRecord.uid)
                    }
                }
            //    } 
            })
            return options;
        }
    },
    {
        label : "FPOD Available",
        includeFilter : ()=>{
           const {shipmentType,shipmentScope} = enquiryStore.current
           if((shipmentType.toLowerCase().includes("lcl") || shipmentType.toLowerCase().includes("fcl")) && (shipmentScope===SHIPMENT_SCOPE.d2d || shipmentScope===SHIPMENT_SCOPE.p2d ) ){
            return true
           }
           return false;
        },
        generateOptions:(records)=>{
            let options = [];
            let keysThatHaveValues = "fpod";
            records?.forEach((record)=>{
            //    if(record[keysThatHaveValues]!==record["fpod"]){
                let value = Utils.isValidValue(record[keysThatHaveValues]);
                if(value){
                    value = Utils.getPortLocation(value);
                    let option = options.find(({title})=>title===value)
                    let curRecord = {...record}
                    if(!option){
                        options.push({title:value,isChecked:false,records:[curRecord.uid]})
                    }else{
                        option.records.push(curRecord.uid)
                    }
                }
            //    } 
            })
            return options;
        }
    },
    {
        label : "AOD Available",
        includeFilter : ()=>{
           const {shipmentType,shipmentScope} = enquiryStore.current
           if((shipmentType.toLowerCase().includes("air")) && (shipmentScope===SHIPMENT_SCOPE.d2d || shipmentScope===SHIPMENT_SCOPE.p2d || shipmentScope===SHIPMENT_SCOPE.d2p) ){
            return true
           }
           return false;
        },
        generateOptions:(records)=>{
            let options = [];
            let keysThatHaveValues = "departure_airport_location";
            records?.forEach((record)=>{
              
                let value = Utils.isValidValue(record[keysThatHaveValues]);
                if(value){
                    value = Utils.getPortLocation(value);
                    let option = options.find(({title})=>title===value)
                    let curRecord = {...record}
                    if(!option){
                        options.push({title:value,isChecked:false,records:[curRecord.uid]})
                    }else{
                        option.records.push(curRecord.uid)
                    }
                }
            })
            return options;
        }
    },
    {
        label : "AOA Available",
        includeFilter : ()=>{
           const {shipmentType,shipmentScope} = enquiryStore.current
           if((shipmentType.toLowerCase().includes("air")) && (shipmentScope===SHIPMENT_SCOPE.d2d || shipmentScope===SHIPMENT_SCOPE.p2d || shipmentScope===SHIPMENT_SCOPE.d2p) ){
            return true
           }
           return false;
        },
        generateOptions:(records)=>{
            let options = [];
            let keysThatHaveValues = "arrival_airport_location";
            records?.forEach((record)=>{
                let value = Utils.isValidValue(record[keysThatHaveValues]);
                if(value){
                    value = Utils.getPortLocation(value);
                    let option = options.find(({title})=>title===value)
                    let curRecord = {...record}
                    if(!option){
                        options.push({title:value,isChecked:false,records:[curRecord.uid]})
                    }else{
                        option.records.push(curRecord.uid)
                    }
                }
            })
            return options;
        }
    }
]